import { colorsPalettes } from "@similarweb/styles";
import { Stack, Text } from "@similarweb/ui-components/foundations";

import { StyledOverlaySubtitle } from "./styles";
type Props = {
    title: string;
    subTitle: string;
};

const OverlayTitleGroup = ({ title, subTitle }: Props) => {
    return (
        <Stack gap="4px">
            <Text
                data-automation="filters-panel.expanded.title"
                fontVariant="h6"
                color={colorsPalettes.carbon[500]}
            >
                {title}
            </Text>

            <StyledOverlaySubtitle data-automation="filters-panel.expanded.subtitle">{subTitle}</StyledOverlaySubtitle>
        </Stack>
    );
};

export default OverlayTitleGroup;
